import { useState, useEffect, useCallback } from "react";
import {
  Form,
  Input,
  Button,
  Space,
  Select,
  Row,
  Col,
  message,
  Spin,
  Divider,
  Card,
} from "antd";
import { MinusCircleOutlined, PlusOutlined } from "@ant-design/icons";
import UserService from "../../services/UserService";
import SystemRolService from '../../services/SystemRolService';
import LoaderSpin from '../Layouts/Loader/LoaderSpin';
import { Redirect } from "react-router-dom";

import { useSelector } from "react-redux";
import { selectUser } from "../../Auth/userReducer";
import CenterService from "../../services/CenterService";

const { Option } = Select;

export default function InvitationRequestWithoutInstitute() {
  const user=useSelector(selectUser);
  const [form] = Form.useForm();
  const [isCharging, setisCharging] = useState(false);
  const [redirect, setredirect] = useState(false);
  const [isLoading, setisLoading] = useState({status:"loading", message:""});
  const [roles, setRoles] = useState([]);
  const [isRequiredCenterSelect, setIsRequiredCenterSelect] = useState(false);
  const [isRequiredInstituteSelect, setIsRequiredInstituteSelect] = useState(false);
  const [listCenters,setListCenters]=useState([])
  // const [listInstitutes,setListInstitutes]=useState([])
  const [centerSelected,setCenterSelected]=useState()
  // const [instituteSelected,setInstituteSelected]=useState()
  // const [sendInvByOpt,setSendInvByOpt]=useState(1)
  

  const listPermissionCenter=[
    "Administrador",
    "Coordinador del instituto",
    "ANIDI - Director",
  ]

  const listPermissionInstitute=[
    "Administrador",
    "ANIDI - Director",
  ]

  function verificityRol() {
    // if(listPermissionInstitute.includes(user.rolName)){
    //   setIsRequiredInstituteSelect(true)
    // }
    // else{
      // setIsRequiredInstituteSelect(false)
      if(listPermissionCenter.includes(user.rolName)){
        setIsRequiredCenterSelect(true)
      }
      else{
        setIsRequiredCenterSelect(false)
      }
    // }
  }

  // const handleOnChangeInstitute=(value)=>{
  //   console.log("value",value)
  //   setInstituteSelected(value)
  //   getListCenters(value)
  //   setCenterSelected()
  // }

  // const getListInstitutes=useCallback(()=>{
  //   if(isRequiredInstituteSelect){
  //     InstituteService.getListInstitutesByRegister().then((res)=>{
  //       console.log("ListInstitute",res?.data?.response);
  //       let centers=res?.data?.response;
  //       let ListInstitutesOpt=[]
  //       centers.map((institute)=>{
  //         ListInstitutesOpt.push({
  //           key: `KI-${institute.id}`,
  //           value: institute.id,
  //           label: `${institute.acronym}-${institute.name}`,
  //         })
  //       }
  //       )
  //       setListInstitutes(ListInstitutesOpt);
  //     });
  //   }
  // })

  const getListCenters=useCallback(()=>{
    if(isRequiredCenterSelect){
      CenterService.getAllCentersWithoutInstitute().then((res)=>{
        console.log("ListCenter",res?.data?.response);
        let centers=res?.data?.response;
        let ListCentersOpt=[]
        ListCentersOpt=centers.map((center)=>{
          return {
            key: `KC-${center.id}`,
            value: center.id,
            label: `${center.acronym}-${center.name}`,
          }
        }
        )
        setListCenters(ListCentersOpt);
      });
    }
  })
  
  const getRoles = () => {
    SystemRolService.getRoles()
    .then((res) => {
      if (res.data?.success) {
        // console.log("user",user)
        let Rol=user.rolName;
        let partialRoles=[];
        // console.log("RolInvitation",Rol)
        switch (Rol) {
          case "Administrador":
            partialRoles = res.data?.response.filter(r => r.name === "DirectorNacional" || r.name === "Administrador" ||  r.name === "Investigador" || r.name === "Asociado" || r.name === "Coordinador del centro" || r.name === "Coordinador del instituto" );
            break;
          case "ANIDI - Director":
            partialRoles = res.data?.response.filter(r => r.name === "Coordinador del centro" );
            break;
          case "Coordinador del instituto" :
            partialRoles = res.data?.response.filter(r => r.name === "Investigador" || r.name === "Asociado" || r.name === "Coordinador del centro" );
            break;
          case "Coordinador del centro" :
              partialRoles = res.data?.response.filter(r => r.name === "Investigador" || r.name === "Asociado");
              break;
        }
        console.log("partialRoles",partialRoles)
        setRoles(partialRoles);
        setisLoading({status:"success",message:""});
      } else {
          message.error("Hubo un error al intentar obtener los roles." + res.data?.description,4);
          setisLoading({status:"error", message:res.data?.description});
      }
    })
    .catch((e) => { 
      message.error("Hubo un error en el servidor." + e.message,4);
      console.log(e.message);
      setisLoading({status:"error", message:e.message});
    });
  }
  
  // const getListCentersByInstitute=()=>{
  //   if(user.rolName==="Coordinador del instituto"){
  //     getListCenters()
  //   }
  // }

  useEffect(() => {
    verificityRol();
    getListCenters()
    getRoles();
  }, [isRequiredCenterSelect,isRequiredInstituteSelect]);

  // useEffect(() => {
  //   console.log("useeffect2")
  //   getListCentersByInstitute();
  // }, [isRequiredCenterSelect]);

  const onFinish = (emails) => {
    if(emails.invitations && emails.invitations.length>0) {
      setisCharging(true);
      // console.log("email",emails)
      // if(user.rolName=="Coordinador del centro"){
      //   if(center.assignedInstitute){
      //     emails.invitations=emails.invitations.map((res)=>(
      //     {...res,
      //       centerId:center.id,
      //       instituteId: center.instituteId,
      //     }
      //     ));
      //   }
      //   else{
      //     emails.invitations=emails.invitations.map((res)=>(
      //       {...res,
      //         centerId:center.id,
      //       }
      //       ));
      //   }
      // }

      // if(user.rolName=="Coordinador del instituto"){
      //   emails.invitations=emails.invitations.map((res)=>(
      //     {...res,
      //       instituteId: institute.id,
      //     }
      //     ));
      // }

      emails.invitations=emails.invitations.map((res)=>(
        {...res,
          assignedInstitute: false,
        }
        ));
        
      // console.log("emailsWithCenter",emails)
      UserService.sendInvitations(emails)
        .then((res) => {
          if (res.data?.success) {
            message.success("Se ha enviado las invitaciones correctamente", 5);
            setisCharging(false);
            setredirect(true);
          } else {
            message.error(res.data?.description, 5);
            //console.log(res.data?.description);
          }
        })
        .catch((e) => {
          message.error(e.message, 5);
          console.log(e.message);
        });
    }else {
      message.error("No registraste ningun email para enviar invitación.",7);
    }
    
  };

  if(isLoading.status === "loading" || isLoading.status === "error" ){
    return (<LoaderSpin isLoading={isLoading} />);
  }

  const filterOption = (input, option) =>
  (option?.label ?? '').toLowerCase().includes(input.toLowerCase());

  const onSearch = (value) => {
    console.log('search:', value);
  };

  

  return (
    <>
      <Form
        form={form}
        name="dynamic_form_nest_item"
        onFinish={onFinish}
        autoComplete="off"
      >
        <Form.List name="invitations">
          {(fields, { add, remove }) => (
            <Row align="start">
              { fields.map((field, index) => (
                <Col
                xs={{ span: 20, offset: 2 }}
                sm={{ span: 20, offset: 2 }}
                md={{ span: 10, offset: 7 }}
                lg={{ span: 10, offset: 7 }}
                xl={{ span: 10, offset: 7 }}
                key={field.key}
              >
                <Card title={`Usuario N ${index+1}`}>
                  <Space align="baseline" split={<Divider type="vertical"/>} direction="vertical">
                  <Form.Item
                    noStyle
                    shouldUpdate={(prevValues, curValues) =>
                      prevValues.sights !== curValues.sights
                    }
                  >
                    {isRequiredCenterSelect &&
                      (<Form.Item
                        {...field}
                        label="Centro"
                        name={[field.name, "centerId"]}
                        fieldKey={[field.fieldKey, "centerId"]}
                        rules={[{ required: isRequiredCenterSelect, message: "Centro faltante." }]}
                      >
                        <Select 
                        showSearch
                        placeholder="Seleccione un centro" 
                        style={{ width: 400 }}
                        optionFilterProp="children"
                        onSearch={onSearch}
                        onChange={setCenterSelected}
                        filterOption={filterOption}
                        options={listCenters}
                        value={centerSelected}
                        >
                        </Select>
                      </Form.Item>)
                    }
                  </Form.Item>
                    <Form.Item
                    noStyle
                    shouldUpdate={(prevValues, curValues) =>
                      prevValues.sights !== curValues.sights
                    }
                    >
                    {() => (
                        <Form.Item
                          {...field}
                          label="Rol"
                          name={[field.name, "systemRolId"]}
                          fieldKey={[field.fieldKey, "systemRolId"]}
                          rules={[{ required: true, message: "Rol faltante."}]}
                        >
                          <Select placeholder="Seleccione un rol" style={{ width: 400 }}>
                            {roles.map((r) => {
                              return <Option key={r.id} value={r.id}>{r.name}</Option>;
                            })}
                          </Select>
                        </Form.Item>
                      )}
                    </Form.Item>
                    <Form.Item
                      {...field}
                      label="Email"
                      name={[field.name, "email"]}
                      fieldKey={[field.fieldKey, "email"]}
                      rules={[
                        {
                          type: "email",
                          required: true,
                          message: "email no valido.",
                        },
                      ]}
                    >
                      <Input placeholder="Ingrese un correo electronico" style={{width:400}}/>
                    </Form.Item>
                    <MinusCircleOutlined onClick={() => remove(field.name)} />
                  </Space>
                </Card>
              </Col>
              ))}
              <Col span={10} offset={7}>
                <Form.Item>
                  <Button
                    type="dashed"
                    onClick={() => add()}
                    block
                    icon={<PlusOutlined />}
                    disabled={isCharging}
                  >
                    Añadir invitación
                  </Button>
                </Form.Item>
              </Col>
            </Row>
          )}
        </Form.List>
        <Row align="center">
          <Col
            xs={{ span: 20 }}
            sm={{ span: 20 }}
            md={{ span: 14 }}
            lg={{ span: 10 }}
            xl={{ span: 10 }}
          >
            <Form.Item>
              <Button type="primary" htmlType="submit" disabled={isCharging}>
                Enviar invitaciones
              </Button>
            </Form.Item>
          </Col>
        </Row>
      </Form>

      <Row justify="center">
        <Col
          span={10}
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          {isCharging ? (
            <>
              <h3 style={{ margin: "1em" }}>Enviando Invitaciones</h3>
              <Spin size="large" />
            </>
          ) : null}
          {redirect ? (
            <>
              <Redirect to="/users"/>
            </>
          ) : null}
        </Col>
      </Row>
    </>
  );
}
